import { ModelBase, ModelState } from '../../core/model/model-base';

export class FastighetsagarnaDokumentTemplate extends ModelBase {
  code: string;
  codeName: string;
  description: string;
  name: string;

  toString() {
    return `${this.codeName}`;
  }
}
